// Papan kerja harian + registri personil per tahap (K50, K125, K126, K127).
//
// ⛔ NOL KONSTANTA BISNIS DI BERKAS INI. Kapasitas per tahap, daftar tahap
// produksi, dan peran datang dari backend — menyalinnya ke frontend berarti
// layar menggambar batas yang bukan batas sebenarnya begitu setelan Owner
// berubah, dan pengguna baru tahu saat pekerjaannya ditolak.
import { api } from "./api";

export { apiErrorMessage } from "./inventoryApi";

// ---------- Papan kerja ----------

/**
 * Beban satu hari di satu region, per tahap, LINTAS SEMUA WO.
 *
 * ⚠ `region_id` DIABAIKAN backend untuk Kepala Cabang — ia selalu melihat
 * regionnya sendiri. Layar tetap mengirimnya supaya Owner bisa berpindah
 * wilayah, dan supaya pagarnya diuji dari sisi yang benar.
 */
export const getPapanKerja = (params) => api.get("/papan-kerja", { params });

/**
 * Daftar wilayah — dipakai HANYA oleh layar papan kerja, dan hanya untuk peran
 * yang nol terikat satu region.
 *
 * ⛔ KENAPA INI ADA. Backend MEWAJIBKAN `region_id` untuk pemanggil yang boleh
 * memilih (Owner), dan itu BENAR: K50 menetapkan SATU PAPAN PER REGION, jadi
 * Owner yang nol menyebut wilayah nol boleh diberi gabungan dua region diam-
 * diam — angkanya akan terbaca sebagai kapasitas satu tempat produksi padahal
 * ia jumlah dua.
 *
 * Yang salah bukan kewajibannya melainkan layar yang MEWAJIBKAN TANPA
 * MENYEDIAKAN CARANYA: sampai 30 Agustus 2026 papan kerja hanya menampilkan
 * "Sebutkan wilayah yang ingin dilihat" dan nol ada satu pun kendali untuk
 * menyebutkannya. Layarnya mati total untuk Owner, dan 13 test papan kerja
 * semuanya hijau karena semuanya memanggil service-nya langsung.
 */
export const getRegions = () => api.get("/regions");

/**
 * ⚠ Mengembalikan RINGKASAN yang memuat KEGAGALANNYA, bukan cuma "berhasil".
 * Layar wajib menampilkannya: mesin yang diam saat nol ada penerima terlihat
 * persis sama dengan mesin yang berhasil mengirim semuanya.
 */
export const kirimTugasHarian = (params) =>
  api.post("/papan-kerja/kirim", null, { params });

// ---------- Geser manual J (K172) ----------

/**
 * Hitung TANPA menulis: tahap yang ikut mundur (B6), melewati deadline (B9).
 * `body`: { ke_tanggal, alasan_kode?, alasan_teks? } — alasan boleh kosong
 * di pratinjau (dialog memanggilnya begitu tanggal dipilih).
 */
export const pratinjauGeser = (woId, stageCode, body) =>
  api.post(`/wo/${woId}/stages/${stageCode}/geser/pratinjau`, body);

/**
 * Simpan geser. `body`: { ke_tanggal, alasan_kode, alasan_teks?, paham_telat? }.
 *
 * ⛔ Guard-nya di backend (G4/G5/G7): dialog hanya menuntun; galat backend
 * tampil verbatim — teksnya milik K172 §6, bukan layar.
 */
export const simpanGeser = (woId, stageCode, body) =>
  api.post(`/wo/${woId}/stages/${stageCode}/geser`, body);

/** Label A3 — kode teknis G3 milik backend, labelnya milik layar. */
export const LABEL_ALASAN_GESER = {
  MESIN_RUSAK: "Mesin rusak",
  STAF_ABSEN: "Staf absen",
  KAPASITAS_PENUH: "Kapasitas penuh",
  LAINNYA: "Lainnya",
};

export const labelAlasanGeser = (kode) => LABEL_ALASAN_GESER[kode] || kode || "—";

// ---------- Registri personil ----------

export const getPersonil = (params) => api.get("/personil", { params });

export const getTahapProduksi = () => api.get("/personil/tahap");

/**
 * ⛔ MENGGANTI seluruh penugasan orang ini, bukan menambah.
 *
 * Layar mengirim daftar lengkap yang dicentang. Pintu yang cuma bisa
 * MENAMBAH akan membuat tahap yang dihapus di layar tetap hidup di database,
 * dan orang itu terus menerima tugas yang sudah bukan urusannya.
 *
 * `tahap`: [{ stage_code, peran }] — peran `KETUA` atau `ANGGOTA`.
 */
export const setTahapPersonil = (employeeId, tahap) =>
  api.put(`/personil/${employeeId}/tahap`, { tahap });

/**
 * Tautan pendaftaran Telegram, berumur pendek dan bertanda tangan.
 *
 * ⚠ Bot Telegram NOL BISA memulai percakapan — staf wajib menekan Start lebih
 * dulu. Tautan ini membuat satu ketukan menyelesaikan keduanya sekaligus.
 */
export const tautanTelegram = (employeeId) =>
  api.post(`/personil/${employeeId}/tautan-telegram`);

export const LABEL_TAHAP = {
  LAYOUT: "Layout",
  PRINT_SUBLIM: "Print / Sublim",
  POTONG: "Potong",
  JAHIT: "Jahit",
  FINISHING: "Finishing",
  QC_PACKING: "QC / Packing",
  // PENGECUALIAN 8 (3 Nov 2026): tahap PENERIMA serah terima (K230), bukan pekerjaan — tampil di layar Personil.
  GUDANG_JADI: "Gudang Barang Jadi",
};

export const labelTahap = (kode) => LABEL_TAHAP[kode] || kode || "—";

// ---------- Group jahit (K129, K130) ----------

/**
 * ⛔ GROUP JAHIT PUNYA PINTUNYA SENDIRI, dan itu bukan kerapian.
 *
 * Penerima tugas JAHIT dibaca dari `sewing_groups`, BUKAN dari
 * `employee_production_stages` seperti lima tahap lain (K29b). Sampai
 * 31 Agustus 2026 layar Personil menawarkan Jahit lewat jalur personil —
 * penugasannya tersimpan, peringatan "belum punya ketua" berhenti menyala,
 * dan tugas Jahit tetap dikirim ke ketua sewing group atau nol terkirim sama
 * sekali. Kendali mati yang membuat lampu jadi hijau.
 */
export const getGroupJahit = (params) => api.get("/group-jahit", { params });

export const buatGroupJahit = (body) => api.post("/group-jahit", body);

/**
 * ⚠ `kosongkan_anggota` terpisah dari `member_employee_id`, dan itu perlu:
 * anggota yang KELUAR dari group wajib bisa dihapus, bukan cuma diganti.
 * Kolom yang hanya bisa diisi akan menyimpan nama orang yang sudah nol
 * bekerja di sana — dan tugas cadangan akan dikirim kepadanya.
 */
export const ubahGroupJahit = (id, body) => api.patch(`/group-jahit/${id}`, body);

// ---------- Matriks personil per tahap (K133) ----------

/**
 * Enam tahap × (Ketua, Anggota) untuk SATU wilayah.
 *
 * ⛔ `region_id` WAJIB, dan backend menolak yang kosong. Gabungan dua wilayah
 * akan terbaca sebagai satu tim padahal ia dua — dan orang wilayah lain akan
 * muncul sebagai calon ketua di sini (K128).
 */
export const getMatriksPersonil = (params) =>
  api.get("/personil/matriks", { params });

/**
 * Isi atau kosongkan satu kotak.
 *
 * ⛔ MENGGANTI ISI = DUA TINDAKAN, dan backend mengerjakan keduanya: orang baru
 * masuk, orang lama DICABUT. Tanpa pencabutan, orang yang sudah keluar terus
 * menerima pesan kerja — chat_id-nya masih sah, dan mesin nol punya cara tahu
 * ia sudah bukan siapa-siapa (K133).
 *
 * `body`: { peran, employee_id } | { peran, orang_baru: {full_name, phone} }
 *       | { peran, kosongkan: true }
 */
export const isiSlotPersonil = (stageCode, body, params) =>
  api.put(`/personil/matriks/${stageCode}`, body, { params });
